import Footerr from "../components/Footerr/Footerr";
import { Header } from "../components/shared";
import usePageMeta from "../../seo/usePageMeta";

const sections = [
  {
    title: "1. Information We Collect",
    body: "We collect information you provide directly, such as your name, email address, phone number, and business details when you submit a contact form, download a resource, book a consultation, or apply for a role. We also collect standard technical information (browser type, device, pages visited) to understand how the site is used.",
  },
  {
    title: "2. How We Use Your Information",
    body: "We use your information to respond to enquiries, deliver resources you request, schedule consultations, evaluate job applications, improve our website and services, and send business communications you have opted into. We do not sell your personal information.",
  },
  {
    title: "3. Sharing of Information",
    body: "We share information only with service providers that help us operate the website and our business (such as form processing, scheduling, and email tools), and only to the extent needed for those services. We may disclose information if required by law.",
  },
  {
    title: "4. Data Retention",
    body: "We retain personal information only for as long as needed for the purposes described above, or as required by applicable law. You may request deletion of your data at any time.",
  },
  {
    title: "5. Your Rights",
    body: "You may request access to, correction of, or deletion of your personal information. To exercise any of these rights, email us at info@terces.io and we will respond within a reasonable timeframe.",
  },
  {
    title: "6. Cookies & Analytics",
    body: "The site may use cookies and similar technologies for essential functionality and aggregate analytics. You can control cookies through your browser settings.",
  },
  {
    title: "7. Contact",
    body: "For any privacy-related questions or requests, contact us at info@terces.io.",
  },
];

function PrivacyPolicyPage() {
  usePageMeta({
    title: "Privacy Policy | Terces Solutions",
    description:
      "How Terces Solutions collects, uses, and protects your personal information.",
    path: "/privacy-policy",
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-3xl mx-auto px-6 pt-32 pb-20">
        <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">
          Privacy Policy
        </h1>
        <p className="text-sm text-gray-500 mb-10">Last updated: July 2026</p>
        <p className="text-gray-700 leading-relaxed mb-8">
          Terces Solutions ("Terces", "we", "us") is committed to protecting
          your privacy. This policy explains what information we collect
          through terces.io, how we use it, and the choices you have.
        </p>
        {sections.map((s) => (
          <section key={s.title} className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-2">{s.title}</h2>
            <p className="text-gray-700 leading-relaxed">{s.body}</p>
          </section>
        ))}
      </main>
      <Footerr />
    </div>
  );
}

export default PrivacyPolicyPage;
